import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import i18n from 'src/utils/translate';
import { Modal } from 'reactstrap';
import { closeModal } from 'src/modules/shared/modal/actions';
import styled from 'styled-components';
import {
  CloseButton,
  Header,
  Title,
} from 'styles-js/modals';

// Overwriting reactstrap modal component
const ModalComponent = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: none;
  height: 100%;
  margin: auto;

  .modal-content {
    max-width: 560px;
    border-radius: 8px;
    border: none;
    overflow: hidden;
    max-height: 90vh;
    @media (max-height: 720px) {
      height: 100%;
      max-height: 100vh;
      border-radius: 0;
    }
  }
`;

const FullscreenModal = styled(ModalComponent)`
  .modal-content {
    @media (max-width: ${props => props.theme.screenXsMin}) {
      height: 100%;
      max-height: 100vh;
      border-radius: 0;
    }
  }
`;

const ResponsiveModal = styled(ModalComponent)`
  // Workaround for IE11, couldn't fix display issue of the footer
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    height: auto;
  }

  .modal-content {
    margin: auto 20px;

    @media (${props => props.theme.underScreenXxsmall}) {
      margin: auto 10px;
    }
  }
`;

const CustomModalNEW = ({
  children,
  closeModal,
  customHeader,
  noClose,
  onClose,
  responsive,
  title,
}) => {

  const renderHeader = () => (
    <Header responsive={!!responsive}>
      {!!title && <Title>{title}</Title>}
      <CloseButton
        className="btn"
        onClick={() => {
          onClose();
          closeModal();
        }}
      >
        <span>{i18n.t('Close')}</span>
        <span className="icon icon-cross-2" />
      </CloseButton>
    </Header>
  );

  const Container = responsive ? ResponsiveModal : FullscreenModal;

  return (
    <Container
      backdropClassName="app-modal__backdrop"
      isOpen={true}
      toggle={() => {
        if (noClose) return;
        onClose();
        closeModal();
      }}
    >
      {!customHeader && renderHeader()}
      {children}
    </Container>
  );
};

CustomModalNEW.propTypes = {
  closeModal: PropTypes.func,
  customHeader: PropTypes.bool,
  noClose: PropTypes.bool, // modal can't be dismissed by clicking away from it
  responsive: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
};

CustomModalNEW.defaultProps = {
  customHeader: false,
  noClose: false,
  responsive: false,
  title: null,
  onClose: () => {},
};

const mapStateToProps = state => state.modal;

export default connect(mapStateToProps, { closeModal })(CustomModalNEW);
